import {
  DefaultMachineDetailsType,
  DateAndDataDumpType,
  DateBasedTimeRangeFinite,
  ShiftSegment,
  PciChartDataType,
  DataDumpAggregateReportsType,
} from "./../../../../types";
import { useQuery } from "@apollo/client";
import { midgardClients, DATA_DUMP_QUERY } from "providers/MidgardProvider";
import { ONE_HOUR_OF_MS } from "./../../../../utils/timeUtils";
import {
  getPnlCategoryTimes,
  getTagTimeFromAggregateData,
  isSameDate,
} from "reports/pages/utils";
import {
  PnlCategoriesEnum,
  DataDumpType,
  TimeStampedDataDumpType,
  pnlCategoriesData,
} from "../../../../types";
import { round, ceil } from "lodash";
import { format } from "date-fns";
import { PCI_PIPELINE_NUM_WEEKS } from "../Pipeline/pciPipelineConstants";

// const WEEKLY_PRODUCTION_TARGET = 180; commented out while figuring out e5 (if even possible)

// default sku value taken from https://pci.gke-us-east1.raven-cloud.com/midgard/skus/view_skus/ to determine machineDetails
export const pciMachines = {
  A2: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2840,
    } as DefaultMachineDetailsType,
  },
  A8: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1215,
    } as DefaultMachineDetailsType, // TODO: no sku data available
  },
  A9: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2409,
    } as DefaultMachineDetailsType, // TODO: no sku data available
  },
  B1C2: {
    reportType: 1,
    machineDetails: {
      primaryPort: 4,
      machineCommonSkuScale: 0.1,
      staticRate: 3300,
    } as DefaultMachineDetailsType, // TODO: no sku data available
  },
  B5C4: {
    reportType: 1,
    machineDetails: {
      primaryPort: 4,
      machineCommonSkuScale: 0.1,
      staticRate: 3300,
    } as DefaultMachineDetailsType, // TODO: no sku data available
  },
  B7: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2000,
    } as DefaultMachineDetailsType,
  },
  B8: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1380,
    } as DefaultMachineDetailsType,
  },
  C8: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 0.1,
      staticRate: 6070,
    } as DefaultMachineDetailsType,
  },
  D1: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2100,
    } as DefaultMachineDetailsType,
  },
  D3: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2025.0,
    } as DefaultMachineDetailsType,
  },
  D4: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1055,
    } as DefaultMachineDetailsType,
  },

  D5: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1410.0,
    } as DefaultMachineDetailsType,
  },
  D6: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1380.0,
    } as DefaultMachineDetailsType,
  },
  D7: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1474,
    } as DefaultMachineDetailsType,
  },
  D8: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 0.1,
      staticRate: 5830,
    } as DefaultMachineDetailsType,
  },
  E2: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 0.5,
      staticRate: 1428,
    } as DefaultMachineDetailsType,
  },
  E3: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1996,
    } as DefaultMachineDetailsType,
  },
  E4: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 4673,
    } as DefaultMachineDetailsType,
  },
  E5: {
    reportType: 1,
    machineDetails: {
      primaryPort: 4,
      machineCommonSkuScale: 1,
      staticRate: 3300,
    } as DefaultMachineDetailsType,
  },
  F1: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1851,
    } as DefaultMachineDetailsType,
  },
  F4: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1345,
    } as DefaultMachineDetailsType,
  },
  G2A: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1750,
    } as DefaultMachineDetailsType,
  },
  G3: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 9375,
    } as DefaultMachineDetailsType,
  },
  G4: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2100.0,
      oeeTarget: 57,
    } as DefaultMachineDetailsType,
  },
  G5: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 3115,
    } as DefaultMachineDetailsType,
  },

  G6: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 3471,
    } as DefaultMachineDetailsType,
  },

  G9: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 4035,
    } as DefaultMachineDetailsType,
  },
  H1: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 2100.0,
    } as DefaultMachineDetailsType,
  },
  H2: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1,
    } as DefaultMachineDetailsType, // TODO: PCI definitely did not configure this default right default: 1/hr others are 1000ish/hr
  },
  H3: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1290,
    } as DefaultMachineDetailsType,
  },
  H4: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1106,
    } as DefaultMachineDetailsType,
  },

  H5: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 3172.0,
    } as DefaultMachineDetailsType,
  },
  H6: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 3510,
    } as DefaultMachineDetailsType,
  },
  H7: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },

  "CELL 01": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "CELL 02": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "CELL 03": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "CELL 04": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "CELL 05": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "TRAY HANDLER 01": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "TRAY HANDLER 02": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "TRAY HANDLER 03": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "TRAY HANDLER 04": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "TRAY HANDLER 06": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  "TRAY HANDLER 07": {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 8400,
    } as DefaultMachineDetailsType,
  },
  A5: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1125,
    } as DefaultMachineDetailsType,
  },
  G2B: {
    reportType: 1,
    machineDetails: {
      primaryPort: 1,
      machineCommonSkuScale: 1,
      staticRate: 1750,
    } as DefaultMachineDetailsType,
  },
};

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * this function is used as a helper to determine the amount of time under each tag
 * this finds the time for a single tag and thus is used in combination with a map function
 */
export const pciCombineTimesInDataSet = (
  data: DataDumpType[],
  category: string,
  tag: string | null
) => {
  return data.reduce((agg, { tagName, pnlCategory, ge, lt }) => {
    if (tagName === tag && pnlCategory === category) {
      return agg + (+lt - +ge) / ONE_HOUR_OF_MS;
    } else {
      return agg;
    }
  }, 0);
};

/**
 * this function calculates our total good producing time
 * expected rate 60/min
 * actual units produced =  37
 * good producing time = 37 seconds
 *
 * This metric automatically accounts for speed loss and speed gain
 *
 * @param data data that will be processed
 */
export const pciExpectedProductionCount = (
  data: DataDumpType[],
  { staticRate, machineCommonSkuScale }: DefaultMachineDetailsType
) => {
  return data?.reduce(
    (agg, { skuScale, targetRate, rateDenominator, ge, lt, pnlCategory }) => {
      if (pnlCategory !== "notScheduled") {
        if (skuScale && targetRate) {
          const rateDenominatorV = rateDenominator
            ? rateDenominator / ONE_HOUR_OF_MS
            : 1;

          // potential output is (expected rate of units produced / (Time in milliseconds / time conversion ratio))
          // time conversion ratio ensures that the numerator and denominator have the same unit of time
          const potentialOutput =
            ((targetRate / skuScale) * ((+lt - +ge) / ONE_HOUR_OF_MS)) /
            rateDenominatorV;

          return agg + potentialOutput;
        } else {
          const targetRateStatic = staticRate;
          const rateDenominatorV = rateDenominator
            ? rateDenominator / ONE_HOUR_OF_MS
            : 1;

          const potentialOutput =
            ((targetRateStatic / machineCommonSkuScale) *
              ((+lt - +ge) / ONE_HOUR_OF_MS)) /
            rateDenominatorV;

          return agg + potentialOutput;
        }
      } else {
        return agg;
      }
    },
    0
  );
};

/**
 * This function acconts for real number of tubes produced based on sku's
 *
 * @param data data that will be processed
 */
export const pciAccurateDataSum = (
  data: DataDumpType[],
  { machineCommonSkuScale, primaryPort }: DefaultMachineDetailsType,
  unit = 1
) => {
  return (
    data?.reduce(
      (
        agg,
        {
          netOutput,
          skuScale,
          ticksPort1,
          ticksPort2,
          ticksPort3,
          ticksPort4,
          pnlCategory,
        }
      ) => {
        const ports = { ticksPort1, ticksPort2, ticksPort3, ticksPort4 };
        const portTickCounts = ports[`ticksPort${primaryPort}`];

        if (pnlCategory !== "notScheduled") {
          if (skuScale) {
            const multiplier = skuScale; // our multiplier is an inverse i.e. multiplier of 10 is 0.1 so it acts as more of a divider
            const skuAdjustedNetValue = netOutput / multiplier;

            return agg + skuAdjustedNetValue;
          } else {
            return agg + portTickCounts * (1 / machineCommonSkuScale);
          }
        }
        return agg;
      },
      0
    ) / unit
  );
};

/**
 * Converts a given datadump shift object into an array, with seperated shift, and date
 *
 * @param data DataDump Shift data that will be organized (this will be an object not an array)
 */
export const organizeDataDumpShiftData = (
  data: { ge: string; lt: string; queryData: DataDumpType[] }[],
  shiftSegments: ShiftSegment[]
): DateAndDataDumpType[] => {
  data.sort(({ ge: ge1 }, { ge: ge2 }) => Number(ge1) - Number(ge2));

  return data.map(({ ge, queryData }) => {
    const date = format(Number(ge), "yyyy-MM-dd");

    const shiftName = shiftSegments.find(
      ({ range }) => Number(range.ge) === Number(ge)
    );

    const shift = shiftName ? Number(shiftName.shift.name) : null;

    return {
      date,
      shift,
      dataDump: queryData,
    } as DateAndDataDumpType;
  });
};

/**
 * This function reformats the date attached to a set of data dumps into a less crowded format
 * We also remove the year, because e5 charts get crowded if year is included
 * 1578911400000  -> Jan-13
 *
 * @param dataDumpSetArray Data that will be formatted
 */
export const formatDateOfDataDumpSet = (
  dataDumpSetArray: TimeStampedDataDumpType[]
): DateAndDataDumpType[] => {
  return dataDumpSetArray.map(({ dataDump, ge, lt }) => {
    const date = new Date(Number(ge));
    const stringDate = `${monthNames[date.getMonth()]}-${date.getDate()}`;
    return {
      date: stringDate,
      dataDump,
      ge,
      lt,
    } as DateAndDataDumpType;
  });
};

export const generateFinalDataFormatPCI = (
  dateAndDataDumpData: DateAndDataDumpType[],
  defaultMachineDetails: DefaultMachineDetailsType,
  unit = 1
): PciChartDataType[] => {
  return dateAndDataDumpData.map(dataDumpSet => {
    const netOutput = dataDumpSet.dataDump
      ? pciAccurateDataSum(dataDumpSet.dataDump, defaultMachineDetails, unit)
      : 0;

    const tags = dataDumpSet.dataDump.reduce(
      (acc, { pnlCategory, tagName, ge, lt }) => {
        const totalDumpTime = (Number(lt) - Number(ge)) / ONE_HOUR_OF_MS;

        if (tagName === null) {
          return acc;
        } else {
          if (acc[`${pnlCategory}-${tagName}`]) {
            return {
              ...acc,
              [`${pnlCategory}-${tagName}`]:
                acc[`${pnlCategory}-${tagName}`] + totalDumpTime,
            };
          } else {
            return { ...acc, [`${pnlCategory}-${tagName}`]: totalDumpTime };
          }
        }
      },
      {} as { [tagName: string]: number }
    );

    // calculate oee percentagge
    const pnlCategoryTimes = dataDumpSet.dataDump
      ? getPnlCategoryTimes(dataDumpSet.dataDump)
      : [0, 0, 0, 0, 0];
    const expectedMachineProduction = pciExpectedProductionCount(
      dataDumpSet.dataDump,
      defaultMachineDetails
    );

    const totalTime = pnlCategoryTimes
      ? pnlCategoryTimes.reduce((agg, entry, index) => {
          return index < 4 ? agg + entry : agg; // we wish to exclude planned and none scheduled times
        })
      : 0;

    if (totalTime > 0) {
      const waitingTime = pnlCategoryTimes[0] / totalTime;
      const unplannedTime = pnlCategoryTimes[1] / totalTime;
      const unknownTime = pnlCategoryTimes[2] / totalTime;

      const oeePercent = expectedMachineProduction
        ? round(((netOutput * 1000) / expectedMachineProduction) * 100)
        : 0;

      return {
        date: dataDumpSet.date,
        shift: dataDumpSet.shift,
        netOutput: round(netOutput, 2), // round to 2 decimals
        targetOutput: round(expectedMachineProduction / 1000, 2), // * 1000 so it can match the same unit as netOutput
        [PnlCategoriesEnum.waiting]: round(pnlCategoryTimes[0], 1),
        [PnlCategoriesEnum.unplanned]: round(pnlCategoryTimes[1], 1),
        [PnlCategoriesEnum.unknown]: round(pnlCategoryTimes[2], 1),
        [PnlCategoriesEnum.producing]: round(pnlCategoryTimes[3], 1),
        [PnlCategoriesEnum.notScheduled]: round(pnlCategoryTimes[4], 1),
        [PnlCategoriesEnum.planned]: round(pnlCategoryTimes[5], 1),
        oeePercent, // converting a percent into a whole number and round to 2 digits
        waitingTime: -ceil(waitingTime * 100),
        unplannedTime: -ceil(unplannedTime * 100),
        unknownTime: -ceil(unknownTime * 100),
        ...tags,
      };
    } else {
      return {
        date: dataDumpSet.date,
        shift: dataDumpSet.shift,
        netOutput: round(netOutput, 2), // round to 2 decimals
        targetOutput: round(expectedMachineProduction / 1000, 2), // * 1000 so it can match the same unit as netOutput
        [PnlCategoriesEnum.waiting]: round(pnlCategoryTimes[0], 1),
        [PnlCategoriesEnum.unplanned]: round(pnlCategoryTimes[1], 1),
        [PnlCategoriesEnum.unknown]: round(pnlCategoryTimes[2], 1),
        [PnlCategoriesEnum.producing]: round(pnlCategoryTimes[3], 1),
        [PnlCategoriesEnum.notScheduled]: round(pnlCategoryTimes[4], 1),
        [PnlCategoriesEnum.planned]: round(pnlCategoryTimes[5], 1),
        oeePercent: 0, // if we have 0 total time, we must return a 0
        waitingTime: 0,
        unplannedTime: 0,
        unknownTime: 0,
        ...tags,
      };
    }
  });
};

export const getNumberAndDurationOfSegmentsByCategory = (
  dataDumps?: DataDumpType[]
): { [pnlCategory: string]: { [tagName: string]: number } } | undefined => {
  return dataDumps?.reduce((accum, datum) => {
    const category = datum.pnlCategory || "category";
    const tagName = datum?.tagName;

    accum[category] = !accum[category]
      ? // If category has not yet been added to the return, initialize total
        { total: 1 }
      : // Add to existing category total
        {
          ...accum[category],
          total: accum[category].total + 1,
        };

    // If tagName exists in segment
    if (tagName) {
      accum[category] = !accum[category][tagName]
        ? // If tagName has not yet been added to the return
          {
            ...accum[category],
            [tagName]: 1,
          }
        : // Add to existing tagName total
          {
            ...accum[category],
            [tagName]: accum[category][tagName] + 1,
          };
    }
    return accum;
  }, {});
};

export const processYearlyAndShiftDataForCharts = (
  yearlyDataDumpSetArray: TimeStampedDataDumpType[],
  currentWeekNumber: number,
  shiftDataDump: any[],
  machineDetails: DefaultMachineDetailsType,
  shiftSegments: ShiftSegment[],
  targetDataDumpAggregate: DataDumpAggregateReportsType | undefined,
  targetWeekGeStart: number,
  extraWeekOfData?: DataDumpType[]
) => {
  if (
    shiftDataDump.length === 0 ||
    yearlyDataDumpSetArray.find(
      ({ dataDump }) => dataDump === null || dataDump === undefined
    ) ||
    yearlyDataDumpSetArray.length < 10 || // wait for all 10 data points to load
    !targetDataDumpAggregate
  ) {
    return {
      completedYearlyData: null,
      yearlyTagDataByWeek: null,
      shiftsDataArray: null,
      tagTimeDistributionByShift: null,
      filteredtotalTimePerTagLastWeekData: null,
      lastWeeksWeeklyResults: null,
    };
  }

  const yearlyDataDumpSetDateFormatted = formatDateOfDataDumpSet(
    // format Date for it to be usable in our graphs
    yearlyDataDumpSetArray
  );

  const completedYearlyData = generateFinalDataFormatPCI(
    // various rounding and oee calculations for final format
    yearlyDataDumpSetDateFormatted,
    machineDetails,
    1000
  );

  const lastWeeksWeeklyResults = yearlyDataDumpSetDateFormatted.find(
    ({ ge }) =>
      ge && isSameDate({ date1: ge, date2: new Date(targetWeekGeStart) })
  );

  const totalTimePerTagTargetWeekAggregateData: pnlCategoriesData[] =
    getTagTimeFromAggregateData(targetDataDumpAggregate).filter(
      ({ totalTime }) => totalTime > 0
    );

  // next two lines of code (including the following body) are uesd to calculate oee and other percentages for shiftdata
  // we could probably move this into utils
  const weeklyShiftDataDumpArray = organizeDataDumpShiftData(
    shiftDataDump,
    shiftSegments
  );

  const shiftsDataArray = generateFinalDataFormatPCI(
    weeklyShiftDataDumpArray,
    machineDetails,
    1000
  );

  return {
    completedYearlyData,
    shiftsDataArray,
    lastWeeksWeeklyResults,
    totalTimePerTagTargetWeekAggregateData,
    filteredtotalTimePerTagLastWeekData: totalTimePerTagTargetWeekAggregateData,
  };
};

export const generateUsablePciDataFromDateRanges = (
  dateArray: DateBasedTimeRangeFinite[],
  currentWeekNumber: number,
  tenant: string,
  machemetryId: string,
  shouldSkipQuery: boolean,
  numWeeksInPrevYear: number
): TimeStampedDataDumpType[] => {
  const startWeekNumberPrevYear =
    numWeeksInPrevYear - PCI_PIPELINE_NUM_WEEKS + currentWeekNumber;

  const rangeToSliceStart =
    currentWeekNumber >= PCI_PIPELINE_NUM_WEEKS
      ? currentWeekNumber - PCI_PIPELINE_NUM_WEEKS
      : startWeekNumberPrevYear;

  const rangeToSliceEnd =
    currentWeekNumber >= PCI_PIPELINE_NUM_WEEKS
      ? currentWeekNumber
      : startWeekNumberPrevYear + PCI_PIPELINE_NUM_WEEKS;

  return dateArray
    .slice(rangeToSliceStart, rangeToSliceEnd) // we only want the last PCI_PIPELINE_NUM_WEEKS weeks of data
    .filter(({ ge, lt }) => ge && lt && ge !== lt) // ensure valid time range
    .reduce((acc, { ge: ddSetge, lt: ddSetLt }, index) => {
      // query time ranges required
      if (index <= rangeToSliceEnd) {
        // plus one because jan 1st -> first monday is added to this list at the beginning and it doesn't count as a full week
        // We want no data after a certain index, or our query will fail because ge,lt time does not exist in database yet
        const { loading, error, data } = useQuery(DATA_DUMP_QUERY, {
          skip: shouldSkipQuery,
          client: midgardClients.get(tenant),
          variables: {
            ge: String(ddSetge.getTime()),
            lt: String(ddSetLt.getTime()),
            cKey: tenant,
            machemetryIds: machemetryId,
          },
        });

        if (!loading && data) {
          acc.push({
            ge: ddSetge,
            lt: ddSetLt,
            dataDump: data.dataDump as DataDumpType[],
          } as TimeStampedDataDumpType);
          return acc;
        }
        if (error) {
          console.info("Shift Loading Error", error);
        }
      }
      return acc;
    }, [] as TimeStampedDataDumpType[]);
};

/**
 * This function is used to sum up our data: e.g. we want to know how much of X we produced until the date Y
 * This is necessary because dataDumpAggregate will give data in the given timeframe (i.e. a week)
 * instead of continuously querying, we can simply summate the data from previous entries onto an existing one
 *
 * visual representation:
 * start array:
 *
 *  0 1 2 3 4
 *
 *
 * after method:
 *
 * 0 1 3 6 10
 *
 * @param data Our data from DataDumpAggregates in array format
 * @param unit The factor in which we divide our net output (Default 1, no unit conversion required)
 */
export const getCummulativeSumArray = (
  data: PciChartDataType[],
  netOutputDenominator = 1
) => {
  return data.map((datum, datumIndex, fullDataArray) => {
    const newNetOutput = fullDataArray.reduce((agg, entry, index) => {
      return index <= datumIndex // this ensures that each index only has a summation up until its current point in the array
        ? entry
          ? /* tslint:disable:no-string-literal */
            agg + entry.netOutput / netOutputDenominator // units are what we divide our netOutput by
          : agg // if an entry is null we add nothing
        : agg; // if an entry is beyond the index we're looking for, we also add nothing
    }, 0);
    /* tslint:disable:no-string-literal */
    const isCurrentDatumZero = datum.netOutput === 0;
    return {
      ...datum,
      netOutput: isCurrentDatumZero ? null : newNetOutput,
      /* tslint:disable:no-string-literal */
      existingNetOutput: round(datum.netOutput / netOutputDenominator),
    } as PciChartDataType;
  });
};

/**
 * This method is used to generate a line and attach it to a given dataset
 *  Y = mX + b
 *
 * @param data Data we wish to append our newly generated line into
 * @param newDataName name (key) we want the newly created line to have
 * @param m slope of the newly generated line
 * @param b offset of the line at index 0
 */
export const generateLine = (
  data,
  newDataName: string,
  m: number,
  b: number
) => {
  return data.map((entry, index) => {
    return {
      ...entry,
      [newDataName]: m * index + b,
    };
  });
};

/**
 * This method is used to create a line of best fit for data point (denoted by the key)
 * for any data set. Primarily used for extrapolation of data
 *
 * UTILIZES THE "SUM OF LEAST SQUARES" METHOD to determine slope of best fit
 * @param data
 * @param key
 */
export const generateLineOfBestFit = (
  data: PciChartDataType[],
  nameOfData: string,
  key: string
) => {
  // Find the index which we need to stop calculating slope
  const stoppingIndex = data.findIndex(current => current[key] === null);

  const bigX = data.reduce((agg, entry, index) => {
    return index < stoppingIndex ? agg + index : agg;
  }, 0); // the formula Sum(xi) / n is 0 in our case
  const meanBigX = bigX / stoppingIndex; // find the average of all the X values

  const bigY = data.reduce((agg, entry, index) => {
    return index < stoppingIndex && entry ? agg + entry[key] : agg;
  }, 0); //
  const meanBigY = bigY / stoppingIndex; // find the average of all the Y values

  const slopeNumerator = data.reduce((agg, entry, index) => {
    if (entry && index < stoppingIndex) {
      return agg + (index - meanBigX) * (entry[key] - meanBigY);
    } else {
      return agg;
    }
  }, 0); // numerator of the equation

  const slopeDenominator = data.reduce((agg, entry, index) => {
    if (entry && index < stoppingIndex) {
      return agg + (index - meanBigX) * (index - meanBigX);
    } else {
      return agg;
    }
  }, 0); // denominator of the equation

  const slope = slopeNumerator / slopeDenominator; // use the equation to determine the m value in mX + B
  const constant = data[0] ? data[0][key] : 0; // use the equation to determine the B value in mX + B

  return generateLine(data, nameOfData, slope, constant); // we generate a line and add it to the data to represent our line of best fit
};
